module.exports = __webpack_public_path__ + "iconfont.eot";


//////////////////
// WEBPACK FOOTER
// ./src/packages/button/iconfont.eot?t=1564473778850
// module id = 5
// module chunks = 0